"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require("react");
var _ = require("underscore");

var TableColumnChooser = function (_React$Component) {
  _inherits(TableColumnChooser, _React$Component);

  function TableColumnChooser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableColumnChooser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableColumnChooser.__proto__ || Object.getPrototypeOf(TableColumnChooser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedColumns: _this.props.selectedColumns
    }, _this.containsPrimaryColumn = function (columns) {
      if (_this.props.primaryIds.length === 0) {
        return true;
      }
      return _.some(columns, function (col) {
        return _.contains(_this.props.primaryIds, col);
      });
    }, _this.updateBox = function (event) {
      if (event.target.checked) {
        var selectedColumns = _this.state.selectedColumns.concat(parseInt(event.target.value, 10));
        if (selectedColumns.length > _this.props.maxColumns) {
          _this.props.logInfo(_this.props.language.get("nc_object_list_column_chooser_max_columns", _this.props.maxColumns));
          return;
        }
        _this.props.updateColumns(event.target.value, false);
        _this.setState({ selectedColumns: selectedColumns });
      } else {
        if (_this.state.selectedColumns.length === 1) {
          _this.props.logInfo(_this.props.language.get("nc_column_chooser_at_least_one_column_needed"));
          return;
        }
        var deselectedId = parseInt(event.target.value, 10);
        var _selectedColumns = _.without(_this.state.selectedColumns, deselectedId);
        if (!_this.containsPrimaryColumn(_selectedColumns)) {
          if (_.contains(_this.props.primaryIds, deselectedId)) {
            // Prevent deselection of the last selected primary column, but don't prevent deselecting other columns. Escape hatch for error situations like DEV-5174
            _this.props.logInfo(_this.props.language.get("nc_object_list_column_chooser_info"));
            return;
          }
        }
        _this.props.updateColumns(event.target.value, true);
        _this.setState({ selectedColumns: _selectedColumns });
      }
    }, _this._renderColumnItems = function (columns) {
      return columns.map(function (column) {
        var classes = { primaryColumns: column.primary };
        return React.createElement(
          "li",
          { key: column.id },
          React.createElement(
            "label",
            { className: _.classSet(classes) },
            React.createElement("input", {
              type: "checkbox",
              disabled: column.disabled || false,
              checked: _.contains(_this.state.selectedColumns, column.id),
              name: column.name,
              onChange: _this.updateBox,
              value: column.id
            }),
            column.name
          )
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TableColumnChooser, [{
    key: "splitColumns",
    value: function splitColumns(allColumns) {
      var result = [[], [], []];
      allColumns.forEach(function (column) {
        if (column.isType) {
          result[1].push(column);
        } else if (column.isField) {
          result[2].push(column);
        } else {
          result[0].push(column);
        }
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var numberOfOptions = this.props.allColumns.length;
      var style = "oneColumn";
      if (numberOfOptions > 10 && numberOfOptions <= 20) {
        style = "twoColumns";
      } else if (numberOfOptions > 20) {
        style = "threeColumns";
      }

      var sections = this.splitColumns(this.props.allColumns);
      return React.createElement(
        "div",
        { className: "columnChooserList " + style },
        sections.map(function (section, index) {
          if (section.length === 0) {
            return null;
          }
          return React.createElement(
            "ul",
            { key: String(index) },
            _this2._renderColumnItems(section)
          );
        })
      );
    }
  }]);

  return TableColumnChooser;
}(React.Component);

module.exports = TableColumnChooser;